var styleDataHash = "4bf2cafb";
const injectCss = (() => {
  var css = `._8Gnh1{align-items:center;background:rgba(0,0,0,.5);color:#fff;display:flex;height:100%;justify-content:center;position:absolute;text-align:center;top:0;width:100%}.n-b9n{height:20px;width:20px}.Uca4B{margin-bottom:56px}.-JRnu{font-size:16px;line-height:24px;position:absolute}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var media_item_error_msg_default = {
  "error": "_8Gnh1",
  "errorIcon": "n-b9n",
  "errorIconWithMessage": "Uca4B",
  "errorMsg": "-JRnu"
};
export {
  media_item_error_msg_default as default,
  injectCss
};
//# sourceMappingURL=media-item-error-msg-scss.js.map
